import React from 'react';
import { IonContent, IonPage } from '@ionic/react';
import { RouteComponentProps } from 'react-router';
import { axius, types } from 'utils';
import { Empty, Header, Item, TabsOffset } from 'components';
import { _store, _update } from '_Store';

import './_User.scss';

interface Props extends RouteComponentProps, types.StateProps {}

const Favorites: React.FC<Props> = (props) => {
	const {
		__auth: { favorites },
	} = _store.useState();

	const [data, setData] = React.useState<types.Item[]>(favorites);
	// const [loading, setLoading] = React.useState(false);
	const loading = false;

	React.useEffect(() => {
		// setLoading(true);
		window.scroll(0, 0);
		axius.get(`users/me/favorites`, {}).then((res) => {
			if (res.status === 200) {
				setData(res.data);
				_update.auth('favorites', res.data);
			}
			// setLoading(false);
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<IonPage id="Favorites">
			<Header {...props} showSearch={true} />

			<IonContent fullscreen={false}>
				<div className="p-3 text-center fw-600 title mx-4 mt-4">
					<span className="secondary">YOUR</span>{' '}
					<span className="text-white">FAVOURITES</span>
				</div>

				<div className="p-3">
					{loading &&
						[...Array(4)].map((i) => (
							<div
								key={i}
								className="skeleton mb-4"
								style={{ borderRadius: 7, height: 160 }}
							/>
						))}

					{!loading && data.length === 0 && (
						<Empty
							text="You have not added any items to your favorites."
							style={{}}
						/>
					)}

					{!loading &&
						data.length > 0 &&
						data.map(
							(item, index) =>
								item.status === types.ItemStatuses.PUBLISHED && (
									<div key={item.id + index} className="mb-4">
										<Item
											{...props}
											item={item}
											description={true}
											layout="list"
										/>
									</div>
								)
						)}
				</div>
				<TabsOffset />
			</IonContent>
		</IonPage>
	);
};

export default Favorites;
